import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import _SecureLS from 'secure-ls';
const SecureLS =
  typeof _SecureLS === 'function' ? _SecureLS : (_SecureLS as unknown as { default: typeof _SecureLS }).default;

import {
  adminCloudProducts,
  adminDemos,
  adminDiscounts,
  adminDongles,
  adminInventory,
  adminOrders,
  adminOrganizations,
  adminPendingUsers,
  adminReleases,
  adminUploads,
  adminEmailTemplates,
  adminUsers,
  cloudProducts,
  customerDownloads,
  demo,
  dictionary,
  dongles,
  invoices,
  login,
  organizations,
  shop,
  snackbar,
  support,
  paymentMethods,
  timer,
  adminEdu,
  adminSchools,
  maintenance,
  adminMaintenanceWindows,
} from './modules';
import { initialState } from '@/store/initialState/initialState';
import { APP_MUTATIONS } from '@/store/mutations/mutations';
import { APP_ACTIONS } from '@/store/actions/actions';
import edu from './modules/edu';

const ls = new SecureLS({ isCompression: false });

const store = createStore({
  state: initialState,
  mutations: APP_MUTATIONS,
  actions: APP_ACTIONS,
  getters: {},
  modules: {
    adminDemos,
    adminDiscounts,
    adminDongles,
    adminInventory,
    adminOrganizations,
    adminOrders,
    adminUploads,
    adminEmailTemplates,
    adminReleases,
    adminUsers,
    adminCloudProducts,
    login,
    shop,
    dictionary,
    invoices,
    organizations,
    customerDownloads,
    demo,
    dongles,
    snackbar,
    cloudProducts,
    support,
    adminPendingUsers,
    paymentMethods,
    timer,
    edu,
    adminEdu,
    adminSchools,
    maintenance,
    adminMaintenanceWindows,
  },
  plugins: [
    // createLogger(),
    createPersistedState({
      reducer: (state: Record<string, unknown>) => {
        const { maintenance: _m, adminMaintenanceWindows: _amw, ...rest } = state;
        return rest;
      },
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key),
      },
    }),
  ],
});

export default store;
